import React from "react";
import DynamicTabs from "./DynamicTabs";


const VerticalTabComponent = () => {
  const rightId = localStorage.getItem("RightIdFromSidebar");
  return (
    <div className="container-fluid">
      <DynamicTabs rightId={rightId} />
    </div>
  );
};

export default VerticalTabComponent;
